// extracted by mini-css-extract-plugin
export default {"suggestedPerson":"SuggestedPerson-module__suggestedPerson___nu6Hg","suggestedPerson__name":"SuggestedPerson-module__suggestedPerson__name___lzOHg"};